import { tierName } from '@h2h/shared';
import { Skeleton, TierBadge } from '../../components/ui/bits';
import { ChevronUp } from '../../components/ui/icons';
import { cap, ordinalSuffix } from '../../lib/format';
import { cn } from '../../lib/cn';
import { profileCard } from './tokens';

/** The headline standing card — current tier badge + what it means right now. */
export function StandingCard({
  loading,
  tier,
  tierLabel,
  bestRank,
  isTopTier,
  nextTier
}: {
  loading?: boolean;
  tier: number;
  tierLabel: string;
  bestRank: number | null;
  isTopTier: boolean;
  nextTier: number | null;
}) {
  if (loading) {
    return (
      <div className={cn('flex items-center gap-4 p-[18px]', profileCard)}>
        <Skeleton className="h-[52px] w-[52px]" rounded="rounded-[14px]" />
        <div className="min-w-0 flex-1">
          <Skeleton className="h-[18px] w-32" />
          <Skeleton className="mt-2 h-[13px] w-44" />
        </div>
      </div>
    );
  }

  return (
    <div className={cn('flex animate-fade-in items-center gap-4 p-[18px]', profileCard)}>
      <TierBadge tierIndex={tier} size={52} />
      <div className="min-w-0 flex-1">
        <div className="text-[17px] font-extrabold tracking-tight text-ink">{tierLabel} tier</div>
        <div className="mt-[2px] truncate text-[12.5px] font-medium text-ink2">
          {bestRank ? (
            <>
              Best finish{' '}
              <span className="font-bold text-ink">
                {bestRank}
                {ordinalSuffix(bestRank)}
              </span>{' '}
              in your group
            </>
          ) : (
            'Pick a round to climb the ladder'
          )}
        </div>
      </div>
      {isTopTier ? (
        <span className="shrink-0 rounded-full bg-gradient-to-br from-gold-top to-gold-bottom px-[11px] py-[6px] text-[11px] font-extrabold uppercase tracking-wide text-gold-ink">
          Elite
        </span>
      ) : (
        nextTier != null && (
          <span className="inline-flex shrink-0 items-center gap-[4px] rounded-full bg-accent-wash px-[11px] py-[6px] text-[11px] font-extrabold text-accent-ink">
            <ChevronUp width={13} height={13} strokeWidth={3} />
            {cap(tierName(nextTier))}
          </span>
        )
      )}
    </div>
  );
}
